import React from "react";

import PageHeading from "2g-page-heading";

import { FixniPozadavkyBox } from "b2b/components/fixni-pozadavky-box/FixniPozadavkyBox";

export function FixniPozadavkyBoxExample() {
  return (
    <div>
      <PageHeading>FixniPozadavkyBox</PageHeading>
      <div data-testid="FixniPozadavkyBox">
        <FixniPozadavkyBox />
      </div>
    </div>
  );
}

FixniPozadavkyBoxExample.propTypes = {};

export default React.memo(FixniPozadavkyBoxExample);
